import React, {useEffect, useState} from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import moment from 'moment'

import {Bar, BarBackground} from './styles'

const propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  animationIndex: PropTypes.number,
  status: PropTypes.string,
  className: PropTypes.string,
}
const defaultProps = {
  startDate: undefined as undefined | null,
  endDate: undefined as undefined | null,
  animationIndex: 0,
  status: undefined as undefined | null,
  className: undefined as undefined | null,
}

type ProgressProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const Progress: React.FC<ProgressProps> = ({
  startDate,
  endDate,
  animationIndex,
  status,
  className,
}) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    let frame: number
    const timeout = setTimeout(() => {
      frame = requestAnimationFrame(() => {
        setMounted(true)
      })
    }, 10)
    return () => {
      clearTimeout(timeout)
      cancelAnimationFrame(frame)
    }
  }, [])

  if (!startDate || !endDate) return null

  const progressPercent =
    mounted && startDate && endDate
      ? Math.min(
          (moment().diff(startDate, 'seconds') / moment(endDate).diff(startDate, 'seconds')) * 100,
          100
        )
      : 0

  return (
    <BarBackground className={className ?? undefined}>
      <Bar
        $animationIndex={animationIndex}
        $progress={progressPercent}
        $status={status ?? 'IN_PROGRESS'}
      />
    </BarBackground>
  )
}

Progress.propTypes = propTypes
Progress.defaultProps = defaultProps

export default Progress
